import { createApp } from 'vue'
import App from './App.vue'

const app = createApp(App);

function SetToken(token)
{
    localStorage.setItem('session_token', token);
    console.log(`[main](SetToken) ${token}`);
}

function GetToken()
{
    return localStorage.getItem('session_token');
}

function SetUser(user)
{
    localStorage.setItem('user', user);
    console.log(`[main](SetUser) ${user}`);
}

function GetUser()
{
    return localStorage.getItem('user');
}

function SetUserID(id)
{
    localStorage.setItem('userID', id);
    console.log(`[main](SetUserID) ${id}`);
}

function GetUserID()
{
    const userID = localStorage.getItem('userID');
    return userID !== null ? parseInt(userID) : null;
}

function ClearAll()
{
    localStorage.removeItem('session_token');
    localStorage.removeItem('user');
    localStorage.removeItem('userID');
}

app.config.globalProperties.$SetToken = SetToken;
app.config.globalProperties.$GetToken = GetToken;
app.config.globalProperties.$SetUser = SetUser;
app.config.globalProperties.$GetUser = GetUser;
app.config.globalProperties.$SetUserID = SetUserID;
app.config.globalProperties.$GetUserID = GetUserID;
app.config.globalProperties.$ClearAll = ClearAll;

app.mount('#app');